import {
  IAnalyticsEventExplainWithAi,
  IAnalyticsSummarizeSubjectParams,
} from './types';
import {
  ILlmSummarizeSectionsInput,
  LlmSubjectKind,
} from '../../../apollo/graphqlSchema';
import { AnalyticsErrorContext } from '../error/types';

export const llmSummarizeTrackContexts: Record<LlmSubjectKind, string> = {
  [LlmSubjectKind.Analysis]: 'explain report with ai',
  [LlmSubjectKind.Dashboard]: 'explain dashboard with ai',
};

export const llmSummarizeErrorContexts: Record<
  LlmSubjectKind,
  AnalyticsErrorContext
> = {
  [LlmSubjectKind.Analysis]: AnalyticsErrorContext.ExplainReportWithAi,
  [LlmSubjectKind.Dashboard]: AnalyticsErrorContext.ExplainDashboardWithAi,
};

const subjectObjectTypes: Record<LlmSubjectKind, string> = {
  [LlmSubjectKind.Analysis]: 'report',
  [LlmSubjectKind.Dashboard]: 'dasboard',
};

const summarizeSectionsToContext = (
  sections: ILlmSummarizeSectionsInput,
): string => {
  const arr = [];
  if (sections.executiveSummary) {
    arr.push('executive summary');
  }
  if (sections.keyInsights) {
    arr.push('key insights');
  }
  if (sections.summaryStatistics) {
    arr.push('summary statistics');
  }
  if (sections.recommendations) {
    arr.push('recommendations');
  }
  return arr.join(', ');
};

export const aiResponseReturned = ({
  subjectId,
  sections,
  subjectKind,
}: IAnalyticsSummarizeSubjectParams): IAnalyticsEventExplainWithAi => {
  return {
    eventName: 'AI Response Returned',
    object_type: subjectObjectTypes[subjectKind],
    object_name: 'ai response',
    object_id: subjectId,
    context: summarizeSectionsToContext(sections),
  };
};
